import { CaretDownIcon } from '@phosphor-icons/react'
import type { ComponentProps, CSSProperties, ReactElement } from 'react'

import { Button } from 'app/components/ui/button'
import { cn } from 'app/lib/utils'
import type { ContactJson } from 'app/types/entities'
import { getLeadStatusColorMap } from 'lib/colorMappings'

type LeadStatusTriggerProps = ComponentProps<typeof Button> & {
  status?: ContactJson[`leadStatus`]
}

/** The editable lead status, drawn as a field with its caret always showing so it reads as a
 *  control at rest. Spreads the rest of its props onto the Button, so it works as an `asChild`
 *  menu trigger. */
export function LeadStatusTrigger({ status, className, ...props }: LeadStatusTriggerProps): ReactElement {
  return (
    <Button variant="field" size="xs" type="button" className={cn(`min-w-0 max-w-full`, className)} {...props}>
      {status && (
        <span
          className="inline-block size-1.5 shrink-0 bg-(--lead-status)"
          style={{ '--lead-status': getLeadStatusColorMap(status) } as CSSProperties}
        />
      )}
      <span className={cn(`min-w-0 truncate`, !status && `text-minimal`)}>{status ?? `Set status`}</span>
      <CaretDownIcon weight="bold" className="ml-auto size-3.5 shrink-0 text-subtle" />
    </Button>
  )
}
